import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Badge from "../Badge/Badge";
import Typography from "../Typography/Typography";
import Ripple from "@/shared/components/Button/Ripple";

import { isUrlHasHttpPart } from "../../utils/url/url";
import { getResultsCount } from "../../utils/search/search";
import { handleKeyDownSelectItem } from "../../utils/keyboard-navigation/keyboard-navigation";

import styles from "./SearchAccordionItem.module.scss";

const badgeCountSeparator = " ";

const SearchAccordionItem = ({
  className,
  title,
  url,
  count,
  countMax,
  variant,
  onClick,
  active,
  titleProps,
  id,
  onContextMenu,
  section,
  item,
  tabIndex,
}) => {
  const Tag = url ? "a" : "div";


  const props = {};
  if (url) {
    props.href = url;
    if (isUrlHasHttpPart(url)) {
      props.target = "_blank";
      props.rel = "noopener noreferrer";
    }
  }

  const badgeCount = getResultsCount(count, countMax, badgeCountSeparator);

  const isDisabled = count !== undefined && badgeCount === "0";

  if (isDisabled) {
    props.disabled = isDisabled;
  }

  const handleKeyDownHead = (e) => handleKeyDownSelectItem(e, onClick);

  return (
    <Tag
      {...props}
      tabIndex={tabIndex}
      id={id}
      className={classNames(styles["root"], className, styles[variant], {
        [styles["active"]]: active,
        [styles["disabled"]]: isDisabled,
      })}
      onKeyDown={handleKeyDownHead}
      onClick={onClick}
      onContextMenu={onContextMenu ? (e) => onContextMenu(e, item, section) : null}
    >
      <Typography
        className={styles["item-text"]}
        variant={variant === "tertiary" ? Typography.variant.h5 : Typography.variant.body4}
        color={variant === "tertiary" ? Typography.color.searchSectionPrimary : undefined}
        hoverable={variant === "tertiary"}
        clamp={2}
        dangerouslySetInnerHTML={{ __html: title }}
        {...titleProps}
      />
      {count !== undefined && <Badge number={badgeCount} className={styles["badge-wrap"]} classNameText={styles["badge-text"]}/>}
      <Ripple />
    </Tag>
  );
};

SearchAccordionItem.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  active: PropTypes.bool,
  titleProps: PropTypes.shape(Typography.propTypes),
  title: PropTypes.string,
  url: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  countMax: PropTypes.number,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  section: PropTypes.string,
  tabIndex: PropTypes.number,
  item: PropTypes.object,
};

SearchAccordionItem.defaultProps = {
  variant: "primary",
};

export default SearchAccordionItem;
